export enum PAGE_ENUM_MAP {
  memes = 'MEMES',
}

const pagePathMap = {
  [PAGE_ENUM_MAP.memes]: '/marketing/Memes',
};

export function getPagePath(key?: PAGE_ENUM_MAP) {
  return key ? pagePathMap[key] : location.pathname;
}
